"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The BatchUploadMediaSlideAttachmentsCommand model module.
 * @module model/BatchUploadMediaSlideAttachmentsCommand
 * @version 1.1.3-alpha.1
 */
class BatchUploadMediaSlideAttachmentsCommand {
  /**
   * Constructs a new <code>BatchUploadMediaSlideAttachmentsCommand</code>.
   * @alias module:model/BatchUploadMediaSlideAttachmentsCommand
   * @param media_id {String} 
   * @param batch_id {String} 
   * @param is_topline {Boolean} 
   */
  constructor(media_id, batch_id, is_topline) {
    BatchUploadMediaSlideAttachmentsCommand.initialize(this, media_id, batch_id, is_topline);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_id, batch_id, is_topline) {
    obj['media_id'] = media_id;
    obj['batch_id'] = batch_id;
    obj['is_topline'] = is_topline;
  }

  /**
   * Constructs a <code>BatchUploadMediaSlideAttachmentsCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BatchUploadMediaSlideAttachmentsCommand} obj Optional instance to populate.
   * @return {module:model/BatchUploadMediaSlideAttachmentsCommand} The populated <code>BatchUploadMediaSlideAttachmentsCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BatchUploadMediaSlideAttachmentsCommand();
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('batch_id')) {
        obj['batch_id'] = _ApiClient.default.convertToType(data['batch_id'], 'String');
      }
      if (data.hasOwnProperty('is_topline')) {
        obj['is_topline'] = _ApiClient.default.convertToType(data['is_topline'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>BatchUploadMediaSlideAttachmentsCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BatchUploadMediaSlideAttachmentsCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of BatchUploadMediaSlideAttachmentsCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['batch_id'] && !(typeof data['batch_id'] === 'string' || data['batch_id'] instanceof String)) {
      throw new Error("Expected the field `batch_id` to be a primitive type in the JSON string but got " + data['batch_id']);
    }
    return true;
  }
}
BatchUploadMediaSlideAttachmentsCommand.RequiredProperties = ["media_id", "batch_id", "is_topline"];

/**
 * @member {String} media_id
 */
BatchUploadMediaSlideAttachmentsCommand.prototype['media_id'] = undefined;

/**
 * @member {String} batch_id
 */
BatchUploadMediaSlideAttachmentsCommand.prototype['batch_id'] = undefined;

/**
 * @member {Boolean} is_topline
 */
BatchUploadMediaSlideAttachmentsCommand.prototype['is_topline'] = undefined;
var _default = BatchUploadMediaSlideAttachmentsCommand;
exports.default = _default;